module.exports = __webpack_public_path__ + "SC05_Player.e8ffd4ce.json";